import { render, staticRenderFns } from "./body-composition-analysis.table.vue?vue&type=template&id=27477a61&"
import script from "./body-composition-analysis.table.vue?vue&type=script&lang=js&"
export * from "./body-composition-analysis.table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports